






























































































import {Component, Inject} from "vue-property-decorator";
import Api from "./Api";
import {Company, CompanyRole, DateTime, LocationRole, PendingPerson, PhoneNumber} from "../../modules/models";
import BirthDateInput from "../BirthDateInput.vue";
import CompanySelector from "../companyselector/CompanySelector.vue";
import Phoneinput from "../phoneinput/Phoneinput.vue";
import PersonMarker from "../PersonMarker.vue";
import RoleAdd, {RoleAddData} from "../role-add/RoleAdd.vue";
import UserRequired from "../UserRequired";

@Component({
    components: {
        "at-person-marker": PersonMarker,
        "at-birthdate": BirthDateInput,
        "at-phone-input": Phoneinput,
        "at-company-selector": CompanySelector,
        "at-role-add": RoleAdd,
    }
})
export default class UserAdd extends UserRequired {
    @Inject()
    api!: Api;

    loading = false;

    pendingPersons: PendingPerson[] = [];

    async fetchPending() {
        this.loading = true;
        try {
            this.pendingPersons = await this.api.pendingPersonsList();
        } catch(err){
            this.emitError(err);
        } finally {
            this.loading = false;
        }
    }

    async deletePending(guid: string) {
        this.loading = true;
        try {
            const deleted = await this.api.pendingPersonDelete(guid);
            if(deleted == 1) {
                this.snackTxt = `Ventende bruker slettet`;
            } else {
                this.snackTxt = `Bruker IKKE slettet. Du mangler kanskje rettighet.`
            }
            await this.fetchPending();
        } catch(err) {
            this.emitError(err);
        } finally {
            this.loading = false;
        }
    }

    roleAddPendingPerson: PendingPerson | null = null;
    get showRoleAdd() {
        return this.roleAddPendingPerson != null;
    }
    set showRoleAdd(v: boolean) {
        if(!v) {
            this.roleAddPendingPerson = null;
        }
    }
    async onRoleAdd(data: RoleAddData) {
        this.loading = true;
        try {
            await this.api.pendingPersonRoleAdd(data.orgNum, data.personGuid, data.roleid, data.locid);
            await this.fetchPending(); // Update view of role list
        } catch (e) {
            this.emitError(e);
        } finally {
            this.loading = false;
        }
    }

    async roleRemove(guid: string, r: CompanyRole | LocationRole) {
        try {
            const locid = r instanceof LocationRole ? r.location.id : null;
            const orgnum = r instanceof LocationRole ? r.location.companyOrgNum : r.company.orgNum;
            await this.api.pendingPersonRoleRemove(orgnum, guid, r.role.id, locid);
            this.fetchPending();
            this.snack("Rolle fjernet");
        } catch (e) {
            this.emitError(e);
        }
    }

    firstName = "";
    lastName = "";
    birthDate: DateTime | null = null;
    phone: PhoneNumber | null = null;
    company: Company | null = null;
    phoneErrors: string[] = [];

    checkFirstnameInput() {
        if(this.firstName.length == 0) {
            return "Fornavn må fylles ut";
        }
        return true;
    }
    checkLastnameInput() {
        if(this.lastName.length == 0) {
            return "Etternavn må fylles ut";
        }
        return true;
    }

    snackTxt: string | null = null;
    get showSnack() {
        return this.snackTxt != null;
    }
    set showSnack(v: boolean) {
        if(!v) {
            this.snackTxt = null;
        }
    }
    snack(txt: string) {
        this.snackTxt = txt;
    }

    resetInputs() {
        this.firstName = "";
        this.lastName = "";
        this.birthDate = null;
        this.phone = null;
        this.company = this.baseApi.company;
    }

    async add() {
        this.loading = true;
        try {
            const employedAt: Company[] = [];
            if (this.company != null) {
                employedAt.push(this.company);
            }
            if (this.firstName != null && this.lastName != null && this.phone != null) {
                const toadd = new PendingPerson(null, this.firstName, this.lastName, this.birthDate != null ? this.birthDate.toLocalJsonDate() : null, this.phone, employedAt, DateTime.now(), "", [], []);
                const msg = await this.api.pendingPersonAdd(toadd);
                if(msg.num == 16) { // SMS sent ok
                    this.snack(`Ny ventende bruker lagt til. Bruker må bekrefte med kode mottatt på SMS innen en time.`);
                    this.resetInputs();
                } else if(msg.num == 50) {
                    this.phoneErrors = ["Allerede registrert på eksisterende bruker"];
                } else if(msg.num == 51) {
                    this.phoneErrors = ["Allerede registrert, venter på bekreftelse"];
                } else {
                    this.snack(msg.msg);
                }
                await this.fetchPending();

            } else {
                throw new Error("Navn og telefonnr må være utfyllt");
            }
        } finally {
            this.loading = false;
        }
    }

    cancel() {
        this.$router.go(-1);
    }

    created() {
        this.fetchPending();
        this.company = this.baseApi.company;
    }
}
